export default {
	init: (app, Menu, Submenu, Overlay, Swiper, Plyr) => {
		/*-------- Lazy loading --------*/
		document.querySelectorAll('[data-src], [data-bg]').forEach((item) => app.lazyLoader.observe(item))

		/*-------- Modals --------*/
		document.querySelectorAll('.modal').forEach((item) => {
			app.overlays[item.id] = new Overlay(item)
		})

		/*-------- Menu & Submenus --------*/
		const header = document.querySelector('.header')

		new Menu(
			document.querySelector('.menu-wrapper'),
			document.querySelector('.menu-toggle')
		)

		document.querySelectorAll('.submenu').forEach(submenu => new Submenu(submenu))

		addEventListener('opening', e => {
			if (e.target.classList.contains('submenu')) {
				header.style.setProperty('--submenu-h', `${e.target.getBoundingClientRect().height}px`)
			}
		})

		addEventListener('closing', e => {
			if (e.target.classList.contains('submenu')) {
				header.style.setProperty('--submenu-h', '')
			}
		})

		$('.menu-toggle').on('click', function () {
			$('.submenu').attr('data-state', 'closed');
			$('.menu-link').removeClass('active');
		});

		/*-------- Numbers animate --------*/
		if ($('.items-numbers').length > 0) {
			var reached = false;

			$(window).scroll(function () {
				if (!reached && isScrolledIntoView($('.items-numbers'))) {
					animateNumbers();
					reached = true;
				}
			});

			function isScrolledIntoView(elem) {
				var docViewTop = $(window).scrollTop();
				var docViewBottom = docViewTop + $(window).height();
				var elemTop = elem.offset().top;
				return elemTop <= docViewBottom;
			}

			function animateNumbers() {
				$('.number').each(function () {
					var $this = $(this);
					$({ Counter: 0 }).animate({ Counter: $this.text() }, {
						duration: 2500,
						easing: 'swing',
						step: function (now) {
							$this.text(Math.ceil(now));
						}
					});
				});
			}
		}

		$(document).ready(function () {
			ajusterMenu();
			$(window).scroll(ajusterMenu);
		});

		/*
		|
		| Swiper slider
		|-----------
		*/
		if ($(".swiper-slider").length) {
			const swiperslider = new Swiper(".swiper-slider", {
				slidesPerView: 3,
				spaceBetween: 32,
				navigation: {
					nextEl: '.slider-button-next',
					prevEl: '.slider-button-prev'
				},
				breakpoints: {
					0: {
						slidesPerView: 1.2
					},
					768: {
						slidesPerView: 2
					},
					990: {
						slidesPerView: 3
					}
				},
			});
		}

		/*
		|
		| Swiper actions
		|-----------------
		*/
		if ($(".swiper-actions").length) {
			const swiperactivoffre = new Swiper(".swiper-actions", {
				slidesPerView: 1.15,
				paginationClickable: true,
				spaceBetween: 24,
				navigation: {
					nextEl: '.slider-button-next',
					prevEl: '.slider-button-prev',
				},
				on: {
					init: function () {
						checkNavigation(this);
					},
					resize: function () {
						checkNavigation(this);
					}
				}
			});

			function checkNavigation(swiper) {
				var slidesPerView = swiper.params.slidesPerView;
				var totalSlides = swiper.slides.length;

				if (totalSlides <= slidesPerView) {
					$('.slider-buttons').hide();
				} else {
					$('.slider-buttons').show();
				}
			}
		}

		/*
		|
		| Swiper actions
		|-----------------
		*/
		if ($(".swiper-testimonial").length) {
			const swiperactivoffre = new Swiper(".swiper-testimonial", {
				slidesPerView: 2,
				paginationClickable: true,
				spaceBetween: 24,
				navigation: {
					nextEl: '.slider-button-next',
					prevEl: '.slider-button-prev',
				},
				breakpoints: {
					0: {
						slidesPerView: 1
					},
					768: {
						slidesPerView: 2
					}
				},
				on: {
					init: function () {
						checkNavigation(this);
					},
					resize: function () {
						checkNavigation(this);
					}
				}
			});

			function checkNavigation(swiper) {
				var slidesPerView = swiper.params.slidesPerView;
				var totalSlides = swiper.slides.length;

				if (totalSlides <= slidesPerView) {
					$('.slider-buttons').hide();
				} else {
					$('.slider-buttons').show();
				}
			}
		}


		/*
		|
		| Dropdown accordéon 
		|-----------------
		*/
		if ($(".block-dropdown").length) {
			$('.item .title').click(function () {
				$(this).next('.elem-content').slideToggle('slow');
				$(this).find('.icon-item').toggleClass('plus less');
			});

			// initial
			$('.item').find('.elem-content').hide();
			$('.item-1').find('.icon-item').toggleClass('plus less');
			$('.item-1').find('.elem-content').show();
		}

		/*
		|
		| Plyr
		|-----------------
		*/
		const videoElements = document.querySelectorAll('.plyr-player');
		videoElements.forEach(videoElement => {
			const player = new Plyr(videoElement);
			window.player = player;
		});


		/*
		|
		| Défilement infini
		|-----------------
		*/
		$(document).ready(function () {
			function animateLogos() {
				var $firstItem = $('.partenaires .item:first');
				var itemWidth = $firstItem.outerWidth(true);

				$firstItem.animate({
					marginLeft: -itemWidth
				}, 3000, "linear", function () {
					$firstItem.css('margin-left', '0px').appendTo($firstItem.parent());
					animateLogos();
				});
			}
			animateLogos();
		});


		/*
		|
		| Form
		|-----------------
		*/
		$(document).ready(function () {
			if (window.location.hash === '#gf_2') {
				$('.block-form-join .section-form').css('margin-top', '125px');
				window.location.hash = 'block-form-join';
			}
		});

		/*
		|
		| Menu scroll
		|-----------------
		*/
		$(document).ready(function () {
			var dernierScrollTop = 0; // Garder la trace du dernier scroll
			var delta = 5; // Seuil de déplacement pour déclencher le menu
			var hauteurHeader = $('.header').outerHeight(); // Hauteur du header pour les calculs

			$(window).scroll(function (event) {
				var st = $(this).scrollTop(); // Position actuelle du scroll

				// Assurez-vous que le traitement se fait seulement si l'utilisateur a scrollé d'une distance > delta
				if (Math.abs(dernierScrollTop - st) <= delta) return;

				if (st > dernierScrollTop && st > hauteurHeader) {
					// Scroll vers le bas
					if (!$('.header').hasClass('nav-up')) {
						$('.header').addClass('nav-up');
					}
				} else {
					// Scroll vers le haut
					if (st + $(window).height() < $(document).height()) {
						$('.header').removeClass('nav-up');
					}
				}

				// Traitement spécial pour quand l'utilisateur est tout en haut de la page
				if (st <= 0) {
					$('.header').removeClass('nav-up');
				}

				dernierScrollTop = st; // Mise à jour du dernier scroll pour le prochain mouvement
			});
		});

		/*-------- Menu scroll --------*/
		function ajusterMenu() {
			if ($(window).scrollTop() >= 20) {
				$('.header').addClass('active');
			} else {
				$('.header').removeClass('active');
			}
		}




	}
}